import { ControllershipHubBackendClientConfig } from '@amzn/controllershiphub-typescript-client';
import { AWS_REGION, API_DOMAIN } from 'src/constants/api';

export type Environment = 'prod' | 'beta' | 'gamma' | 'dev';

const ENVIRONMENTS: Environment[] = ['prod', 'gamma', 'beta', 'dev'];
const LOCAL_HOSTNAMES = ['localhost', '127.0.0.1'];

// Same-origin path proxied to beta by the webpack dev server (localhost only).
export const LOCAL_API_PROXY_PATH = '/beta-api';

export const DEFAULT_CLIENT_CONFIG: Partial<ControllershipHubBackendClientConfig> = {
  region: AWS_REGION,
  maxAttempts: 3,
};

export function constructApiUrl(env: Environment | string): string {
  return `https://${env}.chub-api.${API_DOMAIN}`;
}

export function isLocalHost(): boolean {
  return typeof window !== 'undefined' && LOCAL_HOSTNAMES.includes(window.location.hostname);
}

export function getCurrentEnvironment(): Environment | string {
  if (typeof window === 'undefined' || isLocalHost()) {
    return 'beta';
  }

  const hostname = window.location.hostname;
  const envMatch = ENVIRONMENTS.find((env) => hostname.includes(`${env}.controllershiphub`));

  return envMatch || hostname.split('.')[0];
}

export function getApiEndpoint(): string {
  if (isLocalHost()) {
    return `${window.location.origin}${LOCAL_API_PROXY_PATH}`;
  }
  return constructApiUrl(getCurrentEnvironment());
}
